import React from 'react';
import { Card, CardHeader, CardBody, Table, Button, Badge } from 'reactstrap';
import { useMutation } from '@apollo/client';
import { toast } from 'react-toastify';
import { RUN_DELTA_SYNC, RUN_FULL_SYNC } from '@api';

function fmtTime(iso) { return iso ? new Date(iso).toLocaleString() : '—'; }

export default function DeltaSyncPanel({ status, onDone }) {
  const [runDelta, { loading: deltaLoading }] = useMutation(RUN_DELTA_SYNC, {
    onCompleted: (d) => { toast.success(d?.runDeltaSync?.message || 'Delta run'); onDone && onDone(); },
    onError: (e) => toast.error(e.message),
  });
  const [runFull, { loading: fullLoading }] = useMutation(RUN_FULL_SYNC, {
    onCompleted: (d) => { toast.success(d?.runFullSync?.message || 'Full run'); onDone && onDone(); },
    onError: (e) => toast.error(e.message),
  });
  const busy = deltaLoading || fullLoading;

  const totalDrift = (status?.cityCutoffs || []).reduce((s, c) => s + (c.drift || 0), 0);

  return (
    <Card>
      <CardHeader style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <strong>Delta Sync</strong>
        {totalDrift > 0 && <Badge color='warning'>{totalDrift} rows behind</Badge>}
        <span style={{ marginLeft: 'auto' }}>
          <Button size='sm' color='primary' className='mr-1' disabled={busy} onClick={() => runDelta({ variables: {} })}>Run Delta</Button>
          <Button size='sm' color='danger' disabled={busy} onClick={() => {
            if (!window.confirm('Run a FULL sync across all cities? This rebuilds the entire cache.')) return;
            runFull({ variables: {} });
          }}>Run Full</Button>
        </span>
      </CardHeader>
      <CardBody>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, fontSize: 15, marginBottom: 12 }}>
          <div><strong>Interval:</strong> {status?.intervalSec}s</div>
          <div><strong>Last delta:</strong> {fmtTime(status?.lastRunAt)}</div>
          <div><strong>Last duration:</strong> {status?.lastDurationMs != null ? `${status.lastDurationMs}ms` : '—'}</div>
          <div><strong>Last changed:</strong> {status?.lastRowsChanged ?? '—'}</div>
          <div style={{ gridColumn: '1 / span 2' }}><strong>Last full sync:</strong> {fmtTime(status?.lastFullSyncAt)}</div>
        </div>
        <div style={{ maxHeight: 220, overflowY: 'auto' }}>
          <Table size='sm' className='mb-0'>
            <thead>
              <tr><th>City</th><th>Cutoff</th><th>Drift</th></tr>
            </thead>
            <tbody>
              {(status?.cityCutoffs || []).map((c) => (
                <tr key={c.cityId}>
                  <td>{c.cityName || `city#${c.cityId}`}</td>
                  <td>{c.maxUpdatedAt ? new Date(c.maxUpdatedAt).toLocaleString() : <span style={{ color: '#c00' }}>none</span>}</td>
                  <td>{c.drift > 0 ? <Badge color='warning'>{c.drift}</Badge> : <Badge color='success'>0</Badge>}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </CardBody>
    </Card>
  );
}
